import { css } from '@emotion/react';
import { FeeItem, formatCurrency, formatPoints } from 'shared';

import { theme } from '../../theme';

const styles = {
  container: css`
    white-space: nowrap;
  `,
  fee: (align: 'left' | 'right', small: boolean) => css`
    font-size: ${small ? theme.fontSize.sm : theme.fontSize.md};
    font-weight: ${theme.fontWeight.black};
    margin: 0;
    display: flex;
    justify-content: ${align === 'right' ? 'flex-end' : 'flex-start'};
  `,
  originalPoints: css`
    font-weight: ${theme.fontWeight.normal};
    margin-left: ${theme.spacing.sm};
  `,
  lineThrough: css`
    text-decoration: line-through;
  `,
};

type Props = {
  pos: string;
  small?: boolean;
  totalTax: number;
  points: FeeItem;
  align?: 'left' | 'right';
  fallback?: 'points' | 'revenue';
};

export const PointsSummary = ({ pos, points, totalTax, align = 'right', small = false }: Props) => {
  const { amount, discountedPoints } = points;

  const hasDiscountedPoints = discountedPoints ? discountedPoints < amount : false;

  return (
    <div css={styles.container}>
      <p css={styles.fee(align, small)}>
        {hasDiscountedPoints ? (
          <>
            <span>{formatPoints(discountedPoints ?? 0, pos)}</span>{' '}
            <span css={styles.originalPoints}>
              (<span css={styles.lineThrough}>{formatPoints(amount, pos)}</span>)
            </span>
          </>
        ) : (
          <span>{formatPoints(points?.amount, pos)}</span>
        )}
      </p>
      <p css={styles.fee(align, small)}>
        {totalTax >= 0 && '+ '}
        {formatCurrency(totalTax, pos)}
      </p>
    </div>
  );
};
